import React, { useCallback, useEffect, useState } from "react";
import cn from "classnames";
import Spinner from "../common/Spinner";
import categoriesApiClient from "../clients/CategoriesApiClient";
const FilterItem = (props) => {
    const [children, setChildren] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const expanded = props.isSelected(props.item);
    const toggle = useCallback(() => {
        if (expanded) {
            props.unselect(props.item);
        }
        else {
            props.select(props.item);
        }
    }, [expanded]);
    const fetchChildren = async () => {
        var _a, _b;
        setIsLoading(true);
        try {
            const category = await categoriesApiClient.getAuctionCategory(props.item.id, props.auctionId);
            if (props.withActiveItems) {
                category.children = (_a = category.children) === null || _a === void 0 ? void 0 : _a.filter(x => x.hasActiveItems);
            }
            setChildren((_b = category.children) !== null && _b !== void 0 ? _b : []);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (!expanded)
            return;
        if (children.length)
            return;
        void fetchChildren();
    }, [expanded]);
    return (React.createElement("div", { key: props.item.id, className: "productListingPage-filter-category-item" },
        React.createElement("div", { className: "checkboxWithLabel" },
            React.createElement("input", { type: "checkbox", id: props.item.id, value: props.item.id, checked: expanded, onChange: toggle }),
            React.createElement("label", { className: "parent-label", htmlFor: props.item.id }, props.item.displayName)),
        React.createElement("div", { className: cn("productListingPage-filter-category-children", {
                expanded,
            }) },
            isLoading && React.createElement(Spinner, { size: "mini" }),
            children.map((item) => (React.createElement(FilterItem, { key: item.id, item: item, isSelected: props.isSelected, select: props.select, unselect: props.unselect, auctionId: props.auctionId, withActiveItems: props.withActiveItems }))))));
};
export default FilterItem;
